module.exports = __webpack_public_path__ + "img/appStore.72afd122.png";